import { scrollTo } from '../global/scrollTo';

export const pressScroll = () => {
  const target = document.querySelector('.press-template .main-blog-grid-wrapper');

  if (target) {
    const url = location.pathname;
    
    if (url.includes('tagged')) {
      //Just using target.offsetTop won't work. We need to add on the height of the form and the title. 
      const top = document.querySelector('.article-newsletter-signup').getBoundingClientRect().height + document.querySelector('.article-footer').getBoundingClientRect().height;
      if (!isNaN(top) ) {
        scrollTo('.main-blog-static-content-articles', {top: target.offsetTop + top})
      } else {
        scrollTo('.main-blog-static-content-articles')
      }
     
    }
  }
}